export default __webpack_public_path__ + "static/media/Spectral-Bold.79f938af.ttf";